module.exports = __webpack_public_path__ + "static/img/image_app2.13cdcda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page3/image_app2.png
// module id = KRGI
// module chunks = 1